module.exports = __webpack_public_path__ + "img/bg-widget-custom-poll.e4ab797a.svg";